import React, { useMemo } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useAuth } from '../auth/AuthContext'

export default function PeopleTabs() {
  const { user } = useAuth() || { user: null }
  const location = useLocation()
  const roles = Array.isArray(user?.roles) ? user.roles : []
  const isGaUser = roles.some(r => String(r).startsWith('GA_'))
  const isInsurerUser = roles.some(r => String(r).startsWith('INSURER_'))

  const secondLabel = useMemo(() => {
    if (isGaUser) return '원수사 담당자'
    if (isInsurerUser) return 'GA 사용자'
    return '담당자'
  }, [isGaUser, isInsurerUser])

  const activeKey = useMemo(() => {
    if (location.pathname.startsWith('/counterparts')) return 'partners'
    return 'users'
  }, [location.pathname])

  const tabClass = (active) =>
    `px-4 py-2 text-sm border ${active ? 'bg-brand-navy text-white border-brand-navy' : 'bg-white text-slate-700 border-slate-300 hover:bg-slate-50'}`

  return (
    <div className="inline-flex rounded overflow-hidden">
      <Link to="/users" className={tabClass(activeKey === 'users')}>
        우리조직 사용자
      </Link>
      <Link to="/counterparts" className={tabClass(activeKey === 'partners')}>
        {secondLabel}
      </Link>
    </div>
  )
}


